/**
 * Created by jv on 10/02/2021.
 */
const LanguageManager = require("../services/language-manager");
const utils = require("../utils/utils");
const StorageController = require("../services/storage-controller");
const GoogleAnalytics = require("../misc/google-analytics");

//Require the css like any other css file
require("cookieconsent/build/cookieconsent.min.css");
require("script-loader!cookieconsent/build/cookieconsent.min.js"); // requires the cookieconsent library like it was a script tag in the html
// var cookieconsent = require("exports?cookieconsent!cookieconsent/build/cookieconsent.min.js"); // Doesn't rly do much, it still exposes cookieconsent to the window but it now also exports the value
// import CC from "CookieConsent";

const CookieconsentController = {};

(function (CookieconsentController) {
  CookieconsentController.initialize = function () {
    let consentCookie = StorageController.getCookie(StorageController.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT);

    if (utils.isNull(consentCookie)) {
      StorageController.removeCookie("cookieconsent_status");
    }

    window.cookieconsent.initialise({
      "palette": {
        "popup": {
          "background": "#222222",
          "text": "#ffffff"
        },
        "button": {
          "background": "#28aae1",
          "text": "#ffffff"
        }
      },
      "theme": "classic",
      "type": "opt-in",
      "content": {
        "message": LanguageManager.getValueForKey("cookies.message"),
        "deny": LanguageManager.getValueForKey("cookies.button.deny.text"),
        "allow": LanguageManager.getValueForKey("cookies.button.allow.text"),
        "link": LanguageManager.getValueForKey("cookies.link.text"),
        "href": LanguageManager.getValueForKey("cookies.link")
      },
      "cookie": {
        "expiryDays": 365
      },
      "onStatusChange": function (status, chosenBefore) {
        let enableCookies = status === "allow";
        //utils.devLog("User has chosen to '%s' cookies", (enableCookies ? "enabled" : "disable"));
        StorageController.saveCookie(StorageController.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT, enableCookies, 365);

        if (enableCookies) {
          onConsented();
        } else {
          onDeclined();
        }
      }
    });
  }

  function onConsented() {
    console.log(GoogleAnalytics)
    GoogleAnalytics.enable();
    //GoogleAnalytics.triggerPageVisit();
  }

  function onDeclined() {
    GoogleAnalytics.disable();
  }
}(CookieconsentController));

module.exports = CookieconsentController;



// WEBPACK FOOTER //
// ./app/js/services/cookieconsent-controller.js